module.exports = __webpack_public_path__ + "f796c725d2a65618a96611634d2771c1.png";